(function () {
  var RELATIVE_LABELS = ['Hoy', 'Mañana', 'Pasado mañana'];

  function relativeLabel(days) {
    if (days < RELATIVE_LABELS.length) return RELATIVE_LABELS[days];
    return 'en ' + days + ' días';
  }

  function formatRange(minDays, maxDays) {
    if (minDays === maxDays) return relativeLabel(minDays);
    return relativeLabel(minDays) + ' - ' + relativeLabel(maxDays);
  }

  function addDays(date, days) {
    var d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function updateWidget(el) {
    var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
    var shippedMin = parseInt(el.dataset.shippedMin, 10);
    var shippedMax = parseInt(el.dataset.shippedMax, 10);
    var deliveredMin = parseInt(el.dataset.deliveredMin, 10);
    var deliveredMax = parseInt(el.dataset.deliveredMax, 10);

    var now = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);
    if (now >= cutoff) cutoff = addDays(cutoff, 1);

    var remainingMs = cutoff - now;
    var hours = Math.floor(remainingMs / 3600000);
    var minutes = Math.floor((remainingMs % 3600000) / 60000);

    // Worded as time left ("las próximas 2 h 18 min"), never as a clock
    // time — "antes de las 23 horas 42 minutos" read like 23:42.
    var cutoffEl = el.querySelector('[data-dvtb-cutoff]');
    var leadEl = el.querySelector('[data-dvtb-cutoff-lead]');
    if (cutoffEl) {
      if (hours > 0) {
        cutoffEl.textContent = hours + ' h' + (minutes > 0 ? ' ' + minutes + ' min' : '');
        if (leadEl) leadEl.textContent = 'las próximas';
      } else {
        cutoffEl.textContent = Math.max(1, minutes) + ' min';
        if (leadEl) leadEl.textContent = 'los próximos';
      }
    }

    var shippedEl = el.querySelector('[data-dvtb-shipped-range]');
    if (shippedEl) {
      shippedEl.textContent = formatRange(shippedMin, shippedMax);
    }

    var deliveredEl = el.querySelector('[data-dvtb-delivered-range]');
    if (deliveredEl) {
      deliveredEl.textContent = formatRange(deliveredMin, deliveredMax);
    }
  }

  function init() {
    document.querySelectorAll('[data-dvtb-shipping-timeline]').forEach(function (el) {
      updateWidget(el);
      clearInterval(el._dvtbShippingInterval);
      el._dvtbShippingInterval = setInterval(function () { updateWidget(el); }, 60000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
